import { useTenant } from "../../onboarding/tenant.context.js";
import { TeamCreateEnterpriseDialog } from "./team-create-enterprise-dialog.js";
import { TeamCreateRegularDialog } from "./team-create-regular-dialog.js";
import type { useCreateTeamDialog } from "./use-create-team-dialog.js";

export const TeamCreateDialog = (
  props: ReturnType<typeof useCreateTeamDialog>["props"]
) => {
  const { type: tenantType } = useTenant();

  return tenantType === "enterprise" ? (
    <TeamCreateEnterpriseDialog {...props} />
  ) : (
    <TeamCreateRegularDialog {...props} />
  );
};
